import { useEffect, useState } from "react";

export function useHasVisited(key: string) {
  const [hasVisited, setHasVisited] = useState<boolean>(() => {
    try {
      return localStorage.getItem(key) === "1";
    } catch {
      return false;
    }
  });

  const markVisited = () => {
    try {
      localStorage.setItem(key, "1");
      setHasVisited(true);
    } catch {}
  };

  const resetVisited = () => {
    try {
      localStorage.removeItem(key);
      setHasVisited(false);
    } catch {}
  };

  return { hasVisited, markVisited, resetVisited };
}
